<template>
  <!-- 预存款管理 -->
  <div class="home-page-container">
    <div class="pre-wrapper">
      <!-- account money 账户资金 -->
      <div class="summary">
        <div class="title">
          <span class="title-label">油站/商户名称：</span>
          <span class="title-info">{{depositsInfo.businessName}}</span>
        </div>
        <el-row>
          <el-col :span="12">
            <div class="balance-account">
              <div class="value">{{((depositsInfo.effectiveBalance || 0) + (depositsInfo.channelFeeBalance || 0)).toFixed(2)}}</div>
              <el-tooltip class="item" effect="light" content="通道费汇总金额+计算总通道费前的金额" placement="top">
                <span class="label">账户汇总可用余额(元) <i class="el-icon-question" style="color: #CDCDD6; font-size:16px"></i></span>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="balance-channel">
              <div class="value">{{depositsInfo.channelFeeBalance || 0}}</div>
              <div class="label">通道费汇总金额(元)</div>
            </div>
            <div class="balance-channelBefore">
              <div class="value">{{depositsInfo.effectiveBalance || 0}}</div>
              <div class="label">计算总通道费前的金额(元)</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- form 查询 -->
      <div class="search">
        <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="searchList"
        @reset="reset(initQuery)"
        @changeTime="(value,model)=>changeTime(value,'searchBar', 'tradingTimeStart', 'tradingTimeEnd')"
        @changeOption="changeOption"
        :loading="tableLoading">
          <template slot="handler">
            <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
            <download-button :downloadApi="downloadDepositsApi" :queryParams="{ ...downloadParams }"></download-button>
          </template>
        </mer-search>
      </div>
    </div>
    <el-card style="margin-top:31px;" shadow="never">
      <!-- tabs 能源切换 -->
      <el-tabs v-model="searchBarOther.subAccountId" @tab-click="handleClick" type="card">
        <el-tab-pane v-for="(item,index) in categoryTypes" :label="item.advanceTradingCategoryShowName" :name="String(item.subAccountId)" :key="index"></el-tab-pane>
      </el-tabs>
      <!-- table 表格 -->
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        style="padding-top:0">
        <template slot="handler" slot-scope="{row}">
          <!-- <el-button-group v-if="row.tradingTypeCode === 3">
            <el-button size="mini" @click="showDetail(row)">查看回执单</el-button>
          </el-button-group> -->
          <el-dropdown
            v-if="row.tradingTypeCode === 3"
            trigger="click"
            @command="openReceipt"
            placement="bottom">
            <el-button type="primary" size="mini" @click="showDetail(row)">
              查看回执单<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in receiptList" :key="index" :command="item">{{`电子回单${index + 1}`}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </mer-table>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import { getDepositsInfoApi, getQueryDepositsTradeTypeApi, getDepositsListApi, downloadDepositsApi, receiptView, queryAdvanceAccountGroup} from '@/api/finance'

// 查询表单配置
let formConfig = [
  { label: '支付时间', type: 'date', modelName: 'tradeTime', model: '', dateType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss', clearable: false },
  { label: '账户归属', type: 'select', modelName: 'accountGroup', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'accountGroupDesc', selectValue: 'accountGroup', clearable: false },
  { label: '交易类型', type: 'select', modelName: 'tradingType', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'name', selectValue: 'code' }
]
// 表格参数配置
let tableConfig = [
  { label: '交易时间', prop: 'tradingTime', width: 150 },
  { label: '订单号', prop: 'orderNo', width: 180  },
  { label: '交易类型', prop: 'tradingTypeName' },
  { label: '金额类型', prop: 'amountTypeName' },
  { label: '交易金额(元)', prop: 'tradingAmount',width: 136 },
  { label: '交易后可用余额(元)', prop: 'effectiveBalance',width: 136 },
  { label: '交易后通道费金额(元)', prop: 'channelFeeBalance',width: 150 },
  { label: '账户归属', prop: 'accountGroupDesc', width: 160 },
  { label: '备注', prop: 'remark', width: 160 },
  { label: '操作', slot: 'handler', fixed: 'right', width: 150 }
]
export default {
  name: 'finance_preDeposits',
  mixins:[ listPage, queryMix ],
  data(){
    return{
      searchBar: {
        accountGroup: ''
      },
      downloadDepositsApi,
      searchBarOther:{
        subAccountId: ''     //请选择交易类型 0   （1 汽油 2 柴油 3 天然气）
      },
      tradeTime:'',
      formConfig: formConfig,
      tableConfig: tableConfig,
      depositsInfo:{
        businessName: '',
        effectiveBalance: 0,
        channelFeeBalance: 0
      },
      categoryTypes:[],
      receiptList: [],
      accountGroupList: [],
      advanceTradingCategoryEnum: {
        GASOLINE: '汽油账户交易',
        DIESEL: '柴油账户交易',
        GAS: '天然气账户交易'
      }
    }
  },
  created(){
    this.$track.pageViewEvent('预存款资金管理', '1621476232')
    this.initPage()
  },
  methods:{
    initPage () {
      this.getDepositsInfo()
      this.getAdvanceAccountGroup()
      this.initQuery()
      this.getQueryProps()
      // this.getTabProps()
    },  
    // 设置默认查询条件，默认时间间隔31天
    initQuery () {
      this.tradeTime = ''
      this.initTime('tradeTime', 30, 'searchBar', true, 'tradingTimeStart','tradingTimeEnd')
      const { tradeTime } = this
      const initObj = { tradeTime: [tradeTime, null] }
      this.setSearchConfig(initObj)
      if (this.accountGroupList[0]) {
        this.searchBar.accountGroup = this.accountGroupList[0].accountGroup
      }
      //重置交易类别
      // this.searchBarOther.tradingCategory = (this.categoryTypes[0]?.code || '') + ''
    },
    // 获取查询条件：交易类型
    async getQueryProps () {
      const { code, result = [] } = await getQueryDepositsTradeTypeApi()
      if(code !== 200) return
      const initObj = { tradingType: result }
      this.setSearchConfig(initObj)
    },
    // 获取查询条件：账户归属
    async getAdvanceAccountGroup () {
      const { code, result = [] } = await queryAdvanceAccountGroup()
      if(code !== 200) return
      const initObj = { accountGroup: result }
      this.setSearchConfig(initObj)
      this.accountGroupList = result
      this.searchBar.accountGroup = result[0].accountGroup
      this.categoryTypes = result[0]?.subAccountList.map(item => {
        item.subAccountId = String(item.subAccountId)
        return item
      })
      this.searchBarOther.subAccountId = this.categoryTypes[0].subAccountId
      this.initList(getDepositsListApi,false,null,this.searchBarOther)
    },
    changeOption (val) {
      const item = this.accountGroupList.find(item => item.accountGroup === val)
      if (item) {
        this.categoryTypes = item.subAccountList.map(i => {
          i.subAccountId = String(i.subAccountId)
          return i
        })
      }
      this.searchBarOther.subAccountId = this.categoryTypes[0].subAccountId
      this.initList(getDepositsListApi,false,null,this.searchBarOther)
    },
    // 获取查询条件：交易类别
    // async getTabProps () {
    //   try{
    //     const { code,result = [] } = await getQueryTradeCategoryApi()
    //     if(code !== 200) return
    //     this.categoryTypes = result || []
    //     this.searchBarOther.tradingCategory = (this.categoryTypes[0]?.code || '') + ''
    //   }catch(e){
    //     console.log(e)
    //   }finally{
    //     this.initList(getDepositsListApi,false,null,this.searchBarOther)
    //   }
    // },
    // 获取账户余额信息
    async getDepositsInfo (data) {
      try{
        const { code, result = {} } = await getDepositsInfoApi(data)
        if(code !== 200) return
        const { businessName = '' , effectiveBalance = '0.00', channelFeeBalance = '0.00' } = result
        this.depositsInfo.businessName = businessName
        this.depositsInfo.effectiveBalance = effectiveBalance
        this.depositsInfo.channelFeeBalance = channelFeeBalance
      }catch(err){
        console.log(err)
      }
    },
    // 表格tab切换,重新请求列表数据(tab,event)
    handleClick () {
      this.search()
    },
    searchList () {
      this.$track.clickEvent('预存款资金管理交易类型', '1621476235', {
        tysj_trade_type: this.searchBar.tradingType
      })
      this.$track.clickEvent('预存款支付时间查询', '1621476236', {
        tysj_start_time: this.searchBar.tradingTimeStart,
        tysj_end_time: this.searchBar.tradingTimeEnd
      })
      this.search()
    },
    //导出
    download () {
      this.downloadFile(downloadDepositsApi,'预存款')
    },
    // 查看回执单
    async showDetail (row) {
      // this.receiptView({ transNumber: row.orderNo, type: 0 })
      this.receiptList = []
      let params = { transNumber: row.orderNo, type: 0 }
      try {
        const { code, result } = await receiptView(params)
        if (code !== 200) return
        this.receiptList = result.urlList
      } catch (error) {
        console.log(error)
      }
    },
    async openReceipt (url) {
        var a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        a.setAttribute("id", "camnpr");
        // a.style.display = 'none'
        document.body.appendChild(a);
        a.click();
    },
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
.pre-wrapper{
  display: flex;
  flex-flow: nowrap;
  justify-content: space-between;
  & > div{
    background: #fff;
  }
  .summary{
    width: 50%;
    margin-right: 30px;
    padding: 20px 25px;
    box-sizing: border-box;
    .title{
      font-size:18px;
      font-weight:500;
      margin-bottom: 25px;
      display: flex;
      .title-label{
        white-space: nowrap;
      }
      .title-info{
        word-break: break-all;
      }
    }
    .balance-account{
      border-left: 3px solid #4B7EFE;
      padding: 10px;
      .label{
        font-size:14px;
        height: 20px;
        line-height: 20px;
      }
      .value{
        font-size:26px;
        font-weight:bold;
        margin-bottom: 13px;
        height: 36px;
        line-height: 36px;
      }
    }
    .balance-channel{
      border-left: 3px solid #E7B911;
      padding-left: 10px;
      margin-bottom: 10px;
      .label{
        font-size:12px;
        height: 17px;
        line-height: 17px;
      }
      .value{
        font-size:14px;
        font-weight:bold;
        margin-bottom: 3px;
        height: 20px;
        line-height: 20px;
      }
    }
    .balance-channelBefore{
      border-left: 3px solid #9A02C9;
      padding-left: 10px;
      .label{
        font-size:12px;
        height: 17px;
        line-height: 17px;
      }
      .value{
        font-size:14px;
        font-weight:bold;
        margin-bottom: 3px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
  .search{
    width: 50%;
    padding: 20px 25px;
    box-sizing: border-box;
  }
}
</style>